// set port of backend
const PORT                = 7321;     // for my private

// base url
//const baseUrl = 'http://localhost:7044';                // my private local

const USER_SERVER   = '/api';

//const SERVER_URL = 'http://127.0.0.1:'+PORT;
const SERVER_URL = 'https://call.zzzmate.com';
//const SOCKET_URL = `ws://localhost:${PORT}/api`;
const SOCKET_URL = `wss://call.zzzmate.com/api`;

//const VONAGE_PHONE_NUMBER = '18043657801';   // if application == test02
//const VONAGE_PHONE_NUMBER = '19123867801';   // if application == test03
const VONAGE_PHONE_NUMBER = '12088757801';   // if application == quickquick

//const REACT_APP_GOOGLE_CLIENT_ID="562347218682-nsa5j871j9dheh2mhb13b30hndv5k447.apps.googleusercontent.com"
const REACT_APP_GOOGLE_CLIENT_ID="749475098575-oofm1cvi49lcepfl4qd6qmt7vcaioa3j.apps.googleusercontent.com";

module.exports = {
    PORT,
    USER_SERVER,
    REACT_APP_GOOGLE_CLIENT_ID,
    SERVER_URL,
    SOCKET_URL,
    VONAGE_PHONE_NUMBER
}

